import { Injectable } from "@angular/core";
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@node_modules/@angular/router";
import { AppComponentBase } from "@shared/common/app-component-base";
import { ApplicationService } from "../application/application.service";
import { NdqrService } from "./ndqr.service";
import { delay, map, Observable, of, switchMap, tap } from 'rxjs';

@Injectable()
export class NdqrGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private readonly ndqrService: NdqrService,
        private readonly applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.ndqrService.getNdqr(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.ndqrService.closeNdqr();
        return true;
    }
}
